module.exports = __webpack_public_path__ + "img/phone.bbc347da.svg";